import { combineReducers } from '@reduxjs/toolkit';

import {
  appointmentBooking,
  browserAutoFill,
  clientApiJourney,
  strategyCollections,
  components,
  cookies,
  cpcCard,
  crmAutoFill,
  dataMappings,
  dynamicHeight,
  errors,
  events,
  experimentation,
  features,
  formConfig,
  legalStatement,
  logRocket,
  lottieAnimationData,
  navigation,
  navigationControls,
  newsletter,
  oneTrustLocale,
  optionalFormConfig,
  paging,
  persistKeyboard,
  progressiveDisplay,
  publicKeys,
  sessionDataPopulation,
  submission,
  submissionStatus,
  supplierMatches,
  theme,
  transition,
  trustedForm,
  userIdentities,
} from '../slices';

const rootReducer = combineReducers({
  appointmentBooking,
  browserAutoFill,
  clientApiJourney,
  strategyCollections,
  components,
  cookies,
  cpcCard,
  crmAutoFill,
  dataMappings,
  dynamicHeight,
  errors,
  events,
  experimentation,
  features,
  formConfig,
  legalStatement,
  logRocket,
  lottieAnimationData,
  navigation,
  navigationControls,
  newsletter,
  oneTrustLocale,
  optionalFormConfig,
  paging,
  persistKeyboard,
  progressiveDisplay,
  publicKeys,
  sessionDataPopulation,
  submission,
  submissionStatus,
  supplierMatches,
  theme,
  transition,
  trustedForm,
  userIdentities,
});

export default rootReducer;
